export function getUniqueListBy<ArrayItem>(arr: Array<ArrayItem>, key: keyof ArrayItem) {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
}
